// @flow
export const UPDATE_SHOWING_DATA: string = 'UPDATE_SHOWING_DATA'
export const UPDATE_ROOT_DATASET: string = 'UPDATE_ROOT_DATASET'
export const SET_SHOWING_DATASET: string = 'SET_SHOWING_DATASET'
export const RESET_SHOWING_DATASET: string = 'RESET_SHOWING_DATASET'
export const SET_INITIAL_PARAMETERS: string = 'SET_INITIAL_PARAMETERS'
export const CHANGE_SORT: string = 'CHANGE_SORT'
export const REQUEST_RELATED: string = 'REQUEST_RELATED'
export const RECIEVE_RELATED: string = 'RECIEVE_RELATED'
export const FAILED_RELATED: string = 'FAILED_RELATED'



// WEBPACK FOOTER //
// ./src/shared/actionTypes/datasetTypes.js